import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useBillingStatus } from '@/hooks/useBillingStatus';

import { useStructure } from '../useStructures';
import BillingPendingStripe from './views/BillingPendingStripe';
import BillingWithStripe from './views/BillingWithStripe';
import NonBilling from './views/NonBilling';

export const Structure = () => {
  const { structureId } = useParams<{ structureId: string }>();
  const { structure, isLoading, error } = useStructure(structureId!);
  const { billingEnabled, stripeSetupComplete } = useBillingStatus();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !error && !structure) {
      navigate('/', { replace: true });
    }
  }, [structure, isLoading, error, navigate]);

  if (isLoading) return null;
  if (!structure) return null;

  if (!billingEnabled) return <NonBilling />;
  if (!stripeSetupComplete) return <BillingPendingStripe />;
  return <BillingWithStripe />;
};
